import React from 'react';
import { FrontPage } from 'abbot-core';
import menuLogo from '../../assets/images/logo-future-well-kids@2x.png';
import foregroundImg from '../../assets/images/U1-T2-0-0b.svg';
import backgroundImg from '../../assets/images/U1-T2-0-0a.svg';

const data = {
  title: 'Nutritious Eating',
  // subTitle: 'Unit 1 | Topic 2',
  intro: (
    <p>
      You may already know that eating the right types of food is important to
      staying healthy, but what types of food are most nutritious? How can you
      make the most nutritious food choices possible?
    </p>
  ),
  logo: menuLogo,
  foregroundImg,
  backgroundImg
};

export default {
  title: 'Welcome',
  path: '/',
  content: <FrontPage data={data} />
};



// WEBPACK FOOTER //
// ./src/data/home/index.js